import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAlignJustify, faCamera, faCodeSimple } from '@fortawesome/sharp-solid-svg-icons'
import type { CoreModel } from '@salescore/core'
import { isCustomModel, isCustomObjectModel, isCustomViewModel, isSnapshotModel } from '@salescore/features'
import type { ReactElement, ReactNode } from 'react'

import { getProviderFromModelName, SourceProviderIcon } from './SourceProviderIcon'

export const CustomModelOrSnapshotIcon = ({ model }: { model: CoreModel }): ReactElement => {
  if (isCustomViewModel(model)) {
    return <FontAwesomeIcon icon={faCodeSimple} width={22} />
  }
  if (isCustomObjectModel(model)) {
    return <FontAwesomeIcon icon={faAlignJustify} width={22} />
  }
  if (isSnapshotModel(model)) {
    return <FontAwesomeIcon icon={faCamera} width={22} />
  }
  return <></>
}

export const ModelIconLabel = ({ model }: { model: CoreModel }): ReactNode => (
  <>
    {isCustomModel(model) || isSnapshotModel(model) ? (
      <CustomModelOrSnapshotIcon model={model} />
    ) : (
      <SourceProviderIcon provider={getProviderFromModelName(model.name)} />
    )}
    <span className="ml-1 whitespace-normal break-words">{model.label}</span>
  </>
)
